<tui-scrollbar>
  <div class="lp-all-statistics">
    <lp-statistics-header
      class="lp-all-statistics__header"
      [title]="'components.lpAllStatistics.labels.title' | translate"
      [description]="'components.lpAllStatistics.labels.description' | translate"
      (changPeriod)="onChangePeriod($event)"
    ></lp-statistics-header>

    <div class="lp-all-statistics__content">
      <div *tuiLet="statisticsSummary$ | async as statisticsSummary" class="widget widget_cards">
        <lp-statistics-card
          cardType="display"
          [count]="statisticsSummary?.listCount"
          [class.tui-skeleton]="statisticsSummaryLoading"
          [class.tui-skeleton_text]="statisticsSummaryLoading"
        ></lp-statistics-card>

        <lp-statistics-card
          cardType="view"
          [count]="statisticsSummary?.readCount"
          [class.tui-skeleton]="statisticsSummaryLoading"
          [class.tui-skeleton_text]="statisticsSummaryLoading"
        ></lp-statistics-card>

        <lp-statistics-card
          cardType="click"
          [count]="statisticsSummary?.linksVisitedCount"
          [class.tui-skeleton]="statisticsSummaryLoading"
          [class.tui-skeleton_text]="statisticsSummaryLoading"
        ></lp-statistics-card>

        <lp-statistics-card
          cardType="discount"
          [count]="statisticsSummary?.discountsUsedCount"
          [class.tui-skeleton]="statisticsSummaryLoading"
          [class.tui-skeleton_text]="statisticsSummaryLoading"
        ></lp-statistics-card>

        <lp-statistics-card
          cardType="product"
          [count]="statisticsSummary?.productsCount"
          [class.tui-skeleton]="statisticsSummaryLoading"
          [class.tui-skeleton_text]="statisticsSummaryLoading"
        ></lp-statistics-card>
      </div>

      <div class="widget widget_chart">
        <lp-statistics-bar-chart
          [data]="(statisticsBar$ | async)?.months"
          [loading]="statisticsBarLoading"
        ></lp-statistics-bar-chart>
      </div>

      <div class="widget widget_table">
        <lp-statistics-table
          [title]="'components.lpAllStatistics.labels.tableProductsTitle' | translate"
          [captions]="productCaptions"
          [data]="(statisticsProducts$ | async)?.products"
          [unionId]="unionId"
          [loading]="statisticsProductsLoading"
        ></lp-statistics-table>
      </div>

      <div class="widget widget_table">
        <lp-statistics-table
          [title]="'components.lpAllStatistics.labels.tableDiscountsTitle' | translate"
          [captions]="discountCaptions"
          [data]="(statisticsDiscounts$ | async)?.entries"
          [unionId]="unionId"
          [loading]="statisticsDiscountsLoading"
        ></lp-statistics-table>
      </div>
    </div>
  </div>
</tui-scrollbar>
